export default __webpack_public_path__ + "static/media/br.c9fc3919.svg";